
export default [{
	path: '/depots',
	component: () => import('@/components/depots/List')
}]
